import { toast } from 'react-toastify';
import APIs from '../../apiUrl';

const CreateReview = async (payload) => {
  try {
    const response = await APIs.post('/create_review', payload);

    if (response?.data?.message === 'success') {
      toast('Created Successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getAllReview = async (payload) => {
  try {
    const response = await APIs.get(
      `/get_all_review/${payload.page}/${payload.limit}`
    );

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getAllMajorReview = async () => {
  try {
    const response = await APIs.get(`/get_all_major_review`);

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const uploadReviewImage = async (payload) => {
  try {
    const response = await APIs.post(`/upload_through_cloudinary`, payload);

    if (response?.data?.message === 'success') {
      toast('successfully uploaded');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const uploadReviewIcon = async (payload) => {
  try {
    const response = await APIs.post(`/upload_through_cloudinary`, payload);

    if (response?.data?.message === 'success') {
      toast('successfully uploaded');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const DeleteReview = async (payload) => {
  try {
    const response = await APIs.post(`/delete_review`, payload);

    if (response?.data?.message === 'success') {
      toast('successfully deleted');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getSingleReviewDetails = async (payload) => {
  try {
    const response = await APIs.get(`/get_single_review/${payload?.Id}`);

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const EditReview = async (payload) => {
  try {
    const response = await APIs.patch(`/edit_review/${payload?._id}`, payload);

    if (response?.data?.message === 'success') {
      toast('successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const SearchForReviewByName = async (payload) => {
  try {
    const response = await APIs.get(
      `/search_for_review_by_name/${payload?.name}/${payload?.page}/${payload?.limit}`
    );

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const ReviewServices = {
  CreateReview,
  getAllReview,
  getAllMajorReview,
  uploadReviewImage,
  uploadReviewIcon,
  DeleteReview,
  getSingleReviewDetails,
  EditReview,
  SearchForReviewByName,
};

export default ReviewServices;
